import React from "react";
import DetailIconWrapper from "@/components/controls/Task/DetailIconWrapper";
import IconContainer from "@/components/ui/icon-container";
import { isOverdue, simpleDate, toLocalDate } from "@/utils/datetime";
import { ISOStringFormat, isToday } from "date-fns";
import { ClockAlertOverdue, DueDate } from "@dreamhub/designsystem/icons";
import Text from "@/components/ui/text";

interface Props {
  dueDate: ISOStringFormat;
  tooltip: string;
  hideTooltip?: boolean;
  className?: string;
}

const DueDateIndicator: React.FC<Props> = ({
  dueDate,
  tooltip,
  hideTooltip = false,
  className
}) => {
  const localDueDate = toLocalDate(dueDate);
  const isDueDateOverdue = isOverdue(localDueDate);
  const isDueToday = isToday(localDueDate);

  return (
    <DetailIconWrapper
      tooltip={hideTooltip ? undefined : tooltip}
      className={className}
    >
      <IconContainer
        size="5"
        color={
          isDueDateOverdue ? "error" : isDueToday ? "warning" : "secondary"
        }
      >
        {isDueDateOverdue ? <ClockAlertOverdue /> : <DueDate />}
      </IconContainer>
      <Text
        variant={
          isDueDateOverdue
            ? "smBodyError"
            : isDueToday
              ? "smBodyWarning"
              : "smBodySecondary"
        }
      >
        {simpleDate(localDueDate, undefined, true)}
      </Text>
    </DetailIconWrapper>
  );
};

export default DueDateIndicator;
